import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Home.css";
import currentArticles from "./articles/currentArticles";
import UpcomingEvent from "./UpcomingEvent";
import currentEvents from "./currentEvents";
import { getEventDate, getEventHours } from "./App";
import UpcomingInfo from "./UpcomingInfo";
import currentInfo from "./currentInfo";

const numberOfItems = 3;
const categoryCards = [
  { title: "Kultura", description: "Muzea, teatry, kina i zabytki.", to: "/kultura" },
  { title: "Gastronomia", description: "Restauracje, kawiarnie i desery.", to: "/gastronomia" },
  { title: "Nauka", description: "Biblioteki, księgarnie i kursy.", to: "/nauka" },
  { title: "Eventy", description: "Sprawdź, co dzieje się w mieście.", to: "/eventy" },
];

function Home(props) {
  const [places, setPlaces] = useState(null);
  const [events, setEvents] = useState(null);
  const [eventNumber, setEventNumber] = useState(0);
  const [celebrationsToShow, setCelebrationsToShow] = useState([]);
  const [loadingItems, setLoadingItems] = useState({ places: true, events: true });
  const [failedItems, setFailedItems] = useState({ places: false, events: false });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    fetchRandomItems("places");
    fetchRandomItems("events");
    setCelebrationsToShow(getUpcomingCelebrations());
  }, []);

  function fetchRandomItems(type) {
    const isPlaces = type === "places";
    const endpoint = isPlaces
      ? process.env.REACT_APP_RANDOM_PLACES_URL
      : process.env.REACT_APP_RANDOM_EVENTS_URL;

    axios({
      method: "GET",
      data: { ip: props.addressIp },
      withCredentials: true,
      url: process.env.REACT_APP_SERVER_URL + endpoint + numberOfItems,
    })
      .then((response) => {
        if (Array.isArray(response.data) && response.data.length > 0) {
          (isPlaces ? setPlaces : setEvents)(response.data);
        }
      })
      .catch((error) => {
        console.error(`Could not load ${type}.`, error);
        setFailedItems((current) => ({ ...current, [type]: true }));
      })
      .finally(() => {
        setLoadingItems((current) => ({ ...current, [type]: false }));
      });
  }

  function getUpcomingCelebrations() {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentDay = now.getDate();

    return currentEvents
      .map((event) => ({
        ...event,
        monthDistance: (event.month - currentMonth + 12) % 12,
      }))
      .filter((event) => event.monthDistance > 0 || event.day >= currentDay)
      .sort((firstEvent, secondEvent) => {
        return firstEvent.monthDistance - secondEvent.monthDistance || firstEvent.day - secondEvent.day;
      })
      .slice(0, numberOfItems);
  }

  function getCarouselLabel(item, type) {
    if (type === "places") return item.title;
    return `${item.title} - ${getEventDate(item)} godz: ${getEventHours(item)}`;
  }

  function getItemLink(item, type) {
    const suffix = type === "places" ? "/profil/" : "/profil_event/";
    return `/${item.category}/${item.subcategory}${suffix}${item._id}`;
  }

  function renderCarousel(items, type, id) {
    return (
      <div className={`home-carousel home-carousel-${type}`}>
        <div id={id} className="carousel slide carousel-fade" data-bs-ride="carousel">
          <div className="carousel-inner">
            {items.slice(0, numberOfItems).map((item, index) => (
              <div className={`carousel-item ${index === 0 ? "active" : ""}`} key={item._id} data-bs-interval="10000">
                <Link to={getItemLink(item, type)}>
                  <img src={item.images[0].img} className="d-block w-100" alt={item.title} />
                  <div className="carousel-caption d-md-block">
                    <h4>{getCarouselLabel(item, type)}</h4>
                    {type === "events" && item.address && <p>{item.address.split(",")[0]}</p>}
                  </div>
                </Link>
              </div>
            ))}
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target={`#${id}`} data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="visually-hidden">Poprzedni</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target={`#${id}`} data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="visually-hidden">Następny</span>
          </button>
        </div>
      </div>
    );
  }

  function renderCarouselState(items, type, id, label) {
    if (items) return renderCarousel(items, type, id);
    if (loadingItems[type]) return <div className="loader" aria-label={`Ładowanie ${label}`} />;
    if (failedItems[type]) return <p className="carousel-error">Nie udało się wczytać {label}. Spróbuj ponownie później.</p>;
    return null;
  }

  const latestArticles = currentArticles.slice(-4).reverse();
  const latestInfo = currentInfo[currentInfo.length - 1];
  const hasCurrentInfo = latestInfo && new Date(latestInfo.date) >= new Date();
  const currentCelebration = celebrationsToShow[eventNumber];

  return (
    <main className="home-page">
      <section className="home-intro home-intro-compact">
        <h1>Miejsca, ludzie i wydarzenia <em>w zasięgu ręki.</em></h1>
        <p className="intro-copy">Inspiracje, które warto mieć na swojej mapie.</p>
      </section>

      <section className="home-section home-section-featured">
        <div className="section-heading"><p className="eyebrow">Na najbliższe dni</p><h2>Ciekawe eventy</h2></div>
        {renderCarouselState(events, "events", "events-carousel", "wydarzeń")}
      </section>

      <section className="home-section">
        <div className="section-heading"><p className="eyebrow">Na weekend i dalej</p><h2>Ciekawe miejsca</h2></div>
        {renderCarouselState(places, "places", "places-carousel", "miejsc")}
      </section>

      {hasCurrentInfo && (
        <section className="home-section home-section-info">
          <div className="section-heading"><p className="eyebrow">Ważne</p><h2>Informacje</h2></div>
          <UpcomingInfo info={latestInfo} />
        </section>
      )}

      {currentCelebration && (
        <section className="home-section home-section-events">
          <div className="section-heading"><p className="eyebrow">Z kalendarza</p><h2>Nadchodzące uroczystości</h2></div>
          <UpcomingEvent event={currentCelebration} />
          <div className="event-navigation" role="navigation" aria-label="Wybór uroczystości">
            {celebrationsToShow.map((event, index) => (
              <button type="button" className={eventNumber === index ? "active" : ""} onClick={() => setEventNumber(index)} key={event.title}>{index + 1}</button>
            ))}
          </div>
        </section>
      )}

      <section className="home-section articles-section">
        <div className="section-heading"><p className="eyebrow">Do poczytania</p><h2>Najnowsze artykuły</h2></div>
        <div className="articles-grid">
          {latestArticles.map((article) => (
            <article className="article-card" key={article.id}>
              <img src={article.image} alt="" />
              <div className="article-card-content">
                <h3>{article.title}</h3>
                <p>{article.rawContent.substring(0, 120)}...</p>
                <Link to={`/artykuly/${article.id}`} className="text-link">Czytaj dalej <span aria-hidden="true">&#8594;</span></Link>
              </div>
            </article>
          ))}
        </div>
        <Link to="/artykuly" className="all-articles-link">Wszystkie artykuły <span aria-hidden="true">&#8594;</span></Link>
      </section>

      <section className="home-section category-section">
        <div className="section-heading"><p className="eyebrow">Szukaj po swojemu</p><h2>Odkryj według kategorii</h2></div>
        <div className="category-grid">
          {categoryCards.map((category) => (
            <Link className="category-card" to={category.to} key={category.title}>
              <span className="category-card-title">{category.title}</span>
              <span className="category-card-description">{category.description}</span>
              <span className="category-card-arrow" aria-hidden="true">&#8594;</span>
            </Link>
          ))}
        </div>
      </section>

    </main>
  );
}

export default Home;
